<template>
    <div :class=classObject>
        <div class="comTitle borderRaduis10">
            <h4>{{ deviceTitle }}</h4>
        </div>
        <div class="comContentBox center-content">
            <el-tabs v-if="!showStyle" v-model="centerTabsValue" type="card">
                <el-tab-pane v-for="item in deviceList" :key="`${deviceTypes}-${item?.id}-${item.name}`"  :label="item.name" :name="item.name"
                    lazy>
                    <DeviceList :deviceId="item.id" :deviceName="item.name" :assetId="assetId" :deviceTypes="deviceTypes"  :energyType="energyType"/>
                </el-tab-pane>
            </el-tabs>
            <div v-else>
                <DeviceList :deviceId="deviceList?.[0]?.id" :deviceName="deviceList?.[0]?.name" :assetId="assetId"
                    :deviceTypes="deviceTypes"  :energyType="energyType"/>
            </div>
        </div>
    </div>
</template>
<script>
const classNames = require('classnames')
import DeviceList from './DeviceList.vue';
import api from "@/api";
export default {
    components: { DeviceList },
    name: "BottomDevice",
    props: {
        assetId: {
            type: String,
            default: "",
        },
        deviceTypes: {
            type: String,
            default: "中央空调主机",
        },
        className: {
            type: String,
            default: ""
        },
        //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
        energyType: {
            type: String,
            default: "cool",
        },
    },
    data() {
        return {
            deviceTitle: "主机系统运行情况",
            centerTabsValue: '全部',
            centerTabsId: null,
            deviceList: [{
                id: "0",
                name: "全部",
            }],
        }
    },
    computed: {
        classObject: function () {
            return classNames({
                'ashComWrap': true,
                'bottomDevice': true,
                [this.className]: !!this.className,
            })
        },
        showStyle: function () {
            return ['风机盘管', '主机能效'].includes(this.deviceTypes)
        },
    },
    methods: {
        //获取设备列表
        async getDeviceList() {
            this.centerTabsValue="全部"
            const params = {
                assetId: this.assetId,
                deviceTypes: this.deviceTypes,
            }
            if (this.deviceTypes === "分集水管" || this.deviceTypes === "分集水器") {
                params.deviceTypes = "分集水管,分集水器"
            }
            if (this.deviceTypes === "主机能效") {
                params.deviceTypes = "中央空调主机"
            }
            let res = await api.ACRGetDeviceList(params);
            if (res && res.data.code == 200) {
                const objAll = {
                    id: "0",
                    name: "全部",
                }
                const arr = []
                console.log("ACRGetDeviceList-----", res);
                Array.isArray(res.data.data) && res.data.data.forEach((item, index) => {
                    if (this.deviceTypes === "分集水管" && item.type.includes("分集水器")) {
                        objAll.id = item.id
                    } else {
                        arr.push(item)
                    }
                })
                arr.unshift(objAll)
                this.deviceList = arr
            } else {
                console.log("获取设备列表失败");
            }
        },
    },
    watch:{
        deviceTypes(){
            !this.showStyle && this.getDeviceList()
        }
    },
    created() {
        !this.showStyle && this.getDeviceList()
    },
    mounted() {

    },
}
</script>
<style  lang="scss" scoped>
.bottomDevice {
    width: 100%;
    // height: 530px;
    margin-top: 12px;
    .borderRaduis10{
        border-radius: 10px;
    }
}

::v-deep .el-tabs {
    background-color: inherit !important;

    .el-tabs__header {
        margin-bottom: 15px !important;
        width: 100% !important;
        border-bottom-width: 1px !important;

        .el-tabs__item {
            border-bottom: 0.005208rem solid #E4E7ED !important;
            background-color: inherit !important;
        }

        .el-tabs__item.is-active {
            border-bottom-color: #fff !important;
        }
    }

    .el-tabs__content {
        padding-top: 0 !important;
    }
}
</style>